
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-the-project",
      function () {
        return require("private-next-pages/about-the-project.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-the-project"])
      });
    }
  